export default __webpack_public_path__ + "static/media/Widowdusk Mitts.be2c65a3.jpg";